export const getCarriersInfo = (carriersToPickup, carriers) => {
  if (carriersToPickup?.length > 0 && carriers?.length > 0) {
    return carriersToPickup.map(carrierPickup => {
      const carrierInfo = carriers?.find(carrier => carrier.id === carrierPickup.carrier_id)

      return { ...carrierInfo, ...carrierPickup }
    })
  }
  return []
}
